export default "__VITE_ASSET__6f1e7f6e__"